import { memo, useEffect, useRef } from "react";
import { Text } from "@repo/ui";
import { useExamTimer } from "../../hooks/useExamTimer";
import styles from "./ExamTimer.module.scss";

export interface ExamTimerProps {
  totalDurationSeconds: number;
  examStartTime: string | null;
  onExpire?: () => void;
  className?: string;
  isPaused?: boolean;
  showUnits?: boolean;
}

export const ExamTimer = memo(
  ({
    totalDurationSeconds,
    examStartTime,
    onExpire,
    className,
    isPaused,
    showUnits = false,
  }: ExamTimerProps) => {
    const { timerDisplay, isExpired } = useExamTimer(
      totalDurationSeconds,
      examStartTime,
      isPaused,
      showUnits,
    );

    const expiredCalledRef = useRef(false);
    useEffect(() => {
      if (
        isExpired &&
        totalDurationSeconds > 0 &&
        onExpire &&
        !expiredCalledRef.current
      ) {
        expiredCalledRef.current = true;
        onExpire();
      }
    }, [isExpired, totalDurationSeconds, onExpire]);

    return (
      <Text
        variant="body"
        size="large"
        weight="emphasized"
        className={className ?? styles.timerText}
      >
        {timerDisplay}
      </Text>
    );
  },
);
